export default __webpack_public_path__ + "static/media/wordpressimg2.55de66be.png";